<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Gerar Boleto</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <label for="dataVencimento">Data de vencimento:</label>
                <div class="input-group">
                    <input [textMask]="masks.data" [formControl]="dataVencimento" type="text" class="form-control"
                        placeholder="20/05/2020">
                </div>
                <app-msg-erro [control]="dataVencimento"></app-msg-erro>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" [disabled]='dataVencimento.invalid' class="btn btn-outline-dark"
            (click)="modal.close('Save click')">enviar</button>
    </div>
</ng-template>


<ng-template #boletoresposta let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Upload resposta boleto</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="col-12 py-4 px-sm-3">
            <label *ngIf="!arquivoRetorno.value" for="file-upload" class="btn btn-primary w-100 btn-icon pointer">
                <i class="mdi mdi-paperclip"></i>
                <span>Adicionar Arquivo</span>
                <input (change)="onFileSelect($event)" accept=".rem,.REM" class="custom-file-input position-absolute"
                    type="file" name="file-upload" id="file-upload">
            </label>

            <button *ngIf="arquivoRetorno.value" (click)="deleteFile()" class="btn btn-icon btn-danger w-100">
                <i class="mdi mdi-close"></i>
                <span>Remover arquivo</span>
            </button>

            <app-msg-erro [control]="arquivoRetorno"></app-msg-erro>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" [disabled]='arquivoRetorno.invalid' class="btn btn-outline-dark"
            (click)="modal.close('Save click')">enviar</button>
    </div>
</ng-template>


<section class="py-4">
    <div *ngIf="tableLoading" class="mx-2 my-4 mx-lg-4 card">
        <div *ngIf="tableLoading" class="p-5 d-flex justify-content-center position-relative">
            <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
        </div>
    </div>

    <div class="row" *ngIf="!tableLoading">
        <div class="col-11" style="padding-left: 20px;">
            <h1>{{faturamentoDetalhadoCliente?.faturamentoDetalhado?.unidade?.nomeFantasia}}</h1>
        </div>


        <div class="col-1" *ngIf="faturamentoDetalhadoCliente!=null && faturaUnidadeFaturante">
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle><i
                        class="mdi mdi-decagram-outline f-22"></i><i class="mdi mdi-details f-12"></i></button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="openModal(content)"
                        *ngIf="faturamentoDetalhadoCliente.faturamentoDetalhado.gerarBoleto">
                        Gerar Boleto
                    </button>

                    <button ngbDropdownItem (click)="gerarRemessaBoleto()"
                        *ngIf="faturamentoDetalhadoCliente.faturamentoDetalhado.gerarBoleto">
                        Gerar Remessa Boleto
                    </button>

                    <button ngbDropdownItem (click)="openModalRemessa(boletoresposta)"
                        *ngIf="faturamentoDetalhadoCliente.faturamentoDetalhado.gerarBoleto">
                        Arquivo Retorno Boleto
                    </button>

                    <button ngbDropdownItem (click)="gerarNota()"
                        *ngIf="faturamentoDetalhadoCliente.faturamentoDetalhado.gerarNota">
                        Gerar Notas
                    </button>



                    <button ngbDropdownItem (click)="cancelarNota()"
                        *ngIf="faturamentoDetalhadoCliente.faturamentoDetalhado.gerarNota">Cancelar Notas</button>
                    <button ngbDropdownItem (click)="enviarAnexos()">Enviar Anexos</button>
                    <button ngbDropdownItem (click)="marcarClientesNaoFaturar()">Não Faturar Clientes</button>
                </div>
            </div>
        </div>




    </div>


    <div *ngIf="!tableLoading" class="mx-2 my-4 mx-lg-4 card">
        <div class="table-responsive">

            <div class="row">
                <p-table #dt [columns]="cols"
                    styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md p-datatable-gridlines p-mt-3"
                    [value]="listaResultado" [paginator]="true" [rows]="quantidadePorPagina" [showCurrentPageReport]="true"
                    exportFilename={{dynamicdownloadName}} csvSeparator=";"
                    selectionMode="single" [(selection)]="faturamento" [first]="first" [scrollable]="true"
                    [scrollHeight]="'calc(100vh - 433px)'">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <!--Removido devido a bug no momento de faturamento - Cartão 9494 -->
                            <th width="70px">
                                    <!--
                                    <button class="btn bg-transparent border-0" (click)="selecionarTodosRegistro()">
                                        <i *ngIf="checkSelecionadosTabela()=='NENHUM'"
                                            class="mdi mdi-checkbox-blank-outline f-22"></i>
                                        <i *ngIf="checkSelecionadosTabela()=='TODOS'"
                                            class="mdi mdi-checkbox-marked f-22"></i>
                                        <i *ngIf="checkSelecionadosTabela()=='ALGUNS'" class="mdi mdi-minus-box f-22"></i>
                                    </button>
                                    -->
                                </th>

                            <th width="250px" *ngFor="let col of cols" [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon [field]="col.field" class="alignRight"></p-sortIcon>
                            </th>
                            <th width="100px">Ações</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[0].field" [showMenu]="false"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter [field]="cols[1].field" matchMode="equals" [showMenu]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-dropdown appendTo="body" [ngModel]="label" [options]="tipoFatura"
                                            (onChange)="filter($event.value)" placeholder="Selecione"
                                            [showClear]="true">
                                            <ng-template let-option pTemplate="item">
                                                <span>{{option.label}}</span>
                                            </ng-template>
                                        </p-dropdown>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[2].field" [showMenu]="false"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[3].field" [showMenu]="false"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[4].field" [showMenu]="false"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[5].field" [showMenu]="false"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter [field]="cols[6].field" matchMode="equals" [showMenu]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-dropdown appendTo="body" [ngModel]="label" [options]="statusFaturaCliente2"
                                            (onChange)="filter($event.value)" placeholder="Selecione"
                                            [showClear]="true">
                                            <ng-template let-option pTemplate="item">
                                                <span>{{option.label}}</span>
                                            </ng-template>
                                        </p-dropdown>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter [field]="cols[7].field" matchMode="equals" [showMenu]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-dropdown appendTo="body" [ngModel]="label" [options]="statusNfe2"
                                            (onChange)="filter($event.value)" placeholder="Selecione"
                                            [showClear]="true">
                                            <ng-template let-option pTemplate="item">
                                                <span>{{option.label}}</span>
                                            </ng-template>
                                        </p-dropdown>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[8].field" [showMenu]="false"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[9].field" [showMenu]="false"></p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter [field]="cols[10].field" matchMode="equals" [showMenu]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-dropdown appendTo="body" [ngModel]="label" [options]="statusBoletos2"
                                            (onChange)="filter($event.value)" placeholder="Selecione"
                                            [showClear]="true">
                                            <ng-template let-option pTemplate="item">
                                                <span>{{option.label}}</span>
                                            </ng-template>
                                        </p-dropdown>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[11].field" [showMenu]="false">
                                </p-columnFilter>
                            </th>
                            <th>
                                <p-columnFilter type="text" [field]="cols[12].field" [showMenu]="false">
                                </p-columnFilter>
                            </th>
                            <!-- <th *ngFor="let col of cols">
                                <p-columnFilter type="text" [field]="col.field"></p-columnFilter>
                            </th> -->
                            <th></th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index"
                        let-rowIndex="rowIndex">
                        <tr [pSelectableRow]="rowData">

                            <td width="70px">
                                <button
                                    *ngIf="rowData.statusFaturaCliente=='PENDENTE_VERIFICACAO' || rowData.statusFaturaCliente=='VERIFICADO'"
                                    class="btn bg-transparent border-0" (click)="selecionarRegistro(rowData)">
                                    <i *ngIf="!rowData.check" class="mdi mdi-checkbox-blank-outline f-22"></i>
                                    <i *ngIf="rowData.check" class="mdi mdi-checkbox-marked f-22"></i>
                                </button>

                            </td>
                            <td width="250px">{{rowData.idUnidade}}</td>
                            <td width="250px">{{rowData.gerarNota}}</td>
                            <td width="250px">{{rowData.nomeFantasia}}</td>
                            <td width="250px">{{rowData.razaoSocial}}</td>
                            <td width="250px">{{rowData.documento}}</td>
                         <!--   <td width="250px">R$ {{rowData.valorTotal | number:'1.2-2'}}</td>  -->
                            <td width="250px">R$ {{rowData.valorTotalMod}}</td>
                            <td width="250px">
                                <span *ngIf="rowData.statusFaturaCliente!=null">
                                    <span *ngIf="rowData.statusFaturaCliente=='PENDENTE_VERIFICACAO'" class="text-warning">
                                        <i class="mdi mdi-circle-medium" style="font-size:x-large"></i><span>{{rowData.statusFaturaClienteStr}}</span>
                                    </span>
                                    <span *ngIf="rowData.statusFaturaCliente=='VERIFICADO' || rowData.statusFaturaCliente=='FINALIZADO'" class="text-success">
                                        <i class="mdi mdi-circle-medium" style="font-size:x-large"></i><span>{{rowData.statusFaturaClienteStr}}</span>
                                    </span>
                                    <span *ngIf="rowData.statusFaturaCliente=='SEM_CONSUMO'" class="text-info">
                                        <i class="mdi mdi-circle-medium" style="font-size:x-large"></i><span>{{rowData.statusFaturaClienteStr}}</span>
                                    </span>
                                    <span *ngIf="rowData.statusFaturaCliente=='NAO_FATURAR'" class="text-danger">
                                        <i class="mdi mdi-circle-medium" style="font-size:x-large"></i><span>{{rowData.statusFaturaClienteStr}}</span>
                                    </span>
                                </span>
                                <div class="d-flex align-items-center justify-content-end"
                                    style="float:right; display:inline;">

                                    <span (click)="displayEditarStatus=true; editStatus = rowData" class="button-blue"
                                        style="margin-bottom: 2px; margin-right: 2px; margin-left: 2px;"
                                        data-toggle="tooltip" data-placement="bottom" title="Editar Status">
                                        <a class="btn btn-sm btn-icon">
                                            <i class="mdi mdi-pencil">
                                            </i>
                                        </a>
                                    </span>
                                </div>


                            </td>
                            <!-- nota fiscal -->
                            <td width="250px">
                                <div>
                                    <span *ngIf="rowData.statusNfe=='cancelada' || rowData.statusNfe=='error' || rowData.statusNfe=='negada'" class="text-danger"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i><span>{{rowData.statusNfeStr}}</span></span>
                                    <span *ngIf="rowData.statusNfe=='aguardandocancelamento' || rowData.statusNfe=='aguardandoautorizacao'" class="text-warning"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i><span>{{rowData.statusNfeStr}}</span> </span>
                                    <span *ngIf="rowData.statusNfe=='autorizada'" class="text-success"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i><span>{{rowData.statusNfeStr}}</span> </span>
                                    <span *ngIf="rowData.statusNfe==null || rowData.statusNfe=='null'" class="text-primary"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i><span> Não Gerada</span> </span>
                                </div>
                            </td>
                            <td width="250px">
                                <div *ngIf="rowData.statusNfe!=null">
                                    <span>{{rowData.numero}}</span>
                                </div>

                                <div *ngIf="rowData.statusNfe==null">
                                    <span>Não Gerada</span>
                                </div>
                            </td>
                            <td width="250px">
                                <div *ngIf="rowData.statusNfe!=null && rowData.statusNfe!='null'">
                                    <span>{{rowData.dataTransacaoNfe | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                                </div>

                                <div *ngIf="rowData.statusNfe==null || rowData.statusNfe=='null'">
                                    <span>Não Gerada</span>
                                </div>
                            </td>
                            <!-- boleto -->
                            <td width="250px">

                                <span>
                                    <span *ngIf="rowData.statusBoleto=='canceled' || rowData.statusBoleto=='error'" class="text-danger"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i><span>{{rowData.statusBoletoStr}} </span></span>
                                    <span *ngIf="rowData.statusBoleto=='paid' || rowData.statusBoleto=='completed'" class="text-success"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i><span>{{rowData.statusBoletoStr}} </span></span>
                                    <span *ngIf="rowData.statusBoleto=='waiting_approval' || rowData.statusBoleto=='reserved' || rowData.statusBoleto=='pending-analysis' || rowData.statusBoleto=='pending'" class="text-warning"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i><span>{{rowData.statusBoletoStr}}</span></span>
                                    <span  *ngIf="rowData.idBoleto==null" class="text-primary"><i class="mdi mdi-circle-medium"style="font-size:x-large"></i><span> Não Gerado </span></span>
                                </span>
                                <div *ngIf = "rowData.motivoStatusBoleto == 'ENTRADAMANUAL'" class="d-flex align-items-center justify-content-end"
                                style="float:right; display:inline;">
                                    <span (click)="displayEditarStatusBoleto=true; editStatusBoleto = rowData" class="button-blue"
                                        style="margin-bottom: 2px; margin-right: 2px; margin-left: 2px;"
                                        data-toggle="tooltip" data-placement="bottom" title="Editar Status do Boleto">
                                        <a class="btn btn-sm btn-icon">
                                            <i class="mdi mdi-pencil">
                                            </i>
                                        </a>
                                    </span>
                                </div>
                            </td>

                            <td width="250px">
                                <div *ngIf="rowData.statusBoleto!=null">
                                    <span>{{rowData.dataTransacaoBoleto | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                                </div>

                                <div *ngIf="rowData.idBoleto==null">
                                    <span>Não Gerado</span>
                                </div>
                            </td>

                            <td width="250px">
                                <div *ngIf="rowData.statusBoleto!=null || rowData.dataVencimentoBoleto != 'Não Gerada'">
                                    <span>{{rowData.dataVencimentoBoleto | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                                </div>

                                <div *ngIf="rowData.idBoleto==null">
                                    <span>Não Gerado</span>
                                </div>
                            </td>

                            <td width="100px">

                                <div class="d-flex align-items-center justify-content-end"
                                    *ngIf="rowData.statusFaturaCliente=='PENDENTE_VERIFICACAO' || rowData.statusFaturaCliente=='VERIFICADO' || rowData.statusFaturaCliente=='FINALIZADO'">


                                    <!-- <span *ngIf="rowData.statusFaturaCliente!='FINALIZADO'"
                                        (click)="rowDataInfo = rowData; acoesUpload.toggle($event)" class="button-blue"
                                        style="margin-bottom: 2px; margin-right: 2px; margin-left: 2px;"
                                        data-toggle="tooltip" data-placement="bottom" title="Ações de Upload">
                                        <a class="btn btn-sm btn-icon">
                                            <i class="mdi mdi-upload">
                                            </i>
                                        </a>

                                    </span> -->

                                    <span *ngIf="rowData.statusBoleto!=null"
                                        (click)="rowDataInfo = rowData; acoesDownload.toggle($event)"
                                        style="margin-bottom: 2px; margin-left: 2px; margin-right: 2px;"
                                        class="button-blue" data-toggle="tooltip" data-placement="bottom"
                                        title="Ações de Download">
                                        <a class="btn btn-sm btn-icon">
                                            <i class="mdi mdi-download">
                                            </i>
                                        </a>

                                    </span>
                                </div>
                                <div class="d-flex align-items-center justify-content-end"
                                    *ngIf="rowData.statusFaturaCliente=='PENDENTE_VERIFICACAO' || rowData.statusFaturaCliente=='VERIFICADO' || rowData.statusFaturaCliente=='FINALIZADO'">

                                    <span *ngIf="rowData.statusBoleto!=null"
                                        style="margin-top: 2px; margin-right: 2px; margin-left: 2px;"
                                        (click)="rowDataInfo = rowData; op.toggle($event)" class="button-blue"
                                        data-toggle="tooltip" data-placement="bottom" title="Informações de Boleto">
                                        <a class="btn btn-sm btn-icon">
                                            <i class="mdi mdi-information-outline">
                                            </i>
                                        </a>

                                    </span>

                                    <span *ngIf="rowData.statusFaturaCliente!='FINALIZADO'"
                                        style="margin-top: 2px; margin-left: 2px; margin-right: 2px;"
                                        data-toggle="tooltip" data-placement="bottom"
                                        title="Visualizar detalhe de faturamento" class="button-blue">
                                        <a [routerLink]="['/faturamento','detalhe', idFaturamento, 'cliente', rowData.uuidUnidade]"
                                            class="btn btn-sm btn-icon">
                                            <i class="mdi mdi-eye"></i>
                                        </a>
                                    </span>


                                </div>
                            </td>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer" let-columns>
                        <div class="card-footer bg-white row justify-content-between">
                          <div class="pb-2 pb-sm-0">
                            <div class="btn-group" role="group">
                              <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
                                <button type="button" style="min-width: 1rem" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()"
                                  class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom"></button></span>
                              <button (click)="setQuantidadePorPagina(10)" [ngClass]="{'active':  quantidadePorPagina==10}"
                                type="button" class="btn btn-outline-primary">10</button>
                              <button (click)="setQuantidadePorPagina(25)" [ngClass]="{'active':  quantidadePorPagina==25}"
                                type="button" class="btn btn-outline-primary">25</button>
                              <button (click)="setQuantidadePorPagina(50)" [ngClass]="{'active':  quantidadePorPagina==50}"
                                type="button" class="btn btn-outline-primary">50</button>
                              <button (click)="setQuantidadePorPagina(100)" [ngClass]="{'active':  quantidadePorPagina==100}"
                                type="button" class="btn btn-outline-primary">100</button>
                              <button (click)="setQuantidadePorPagina(100000)" [ngClass]="{'active':  quantidadePorPagina==100000}"
                                type="button" class="btn btn-outline-primary">Todos</button>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="columns.length + 1">
                                Nenhum resultado foi encontrado
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>


        </div>

    </div>
</section>



<p-overlayPanel #op [style]="{width: '350px'}">
    <div *ngIf="rowDataInfo.statusBoleto!=null" class="infopainel">
        <p>
            <span *ngIf="rowDataInfo.statusBoleto=='canceled'">Cancelado</span>
            <span *ngIf="rowDataInfo.statusBoleto=='paid'">Pago</span>
            <span *ngIf="rowDataInfo.statusBoleto=='waiting_approval'">Aguardando Remessa</span>
            <span *ngIf="rowDataInfo.statusBoleto=='reserved'">Reservado</span>
            <span *ngIf="rowDataInfo.statusBoleto=='pending-analysis'">Análise Pendente</span>
            <span *ngIf="rowDataInfo.statusBoleto=='error'">Ocorreu Erro</span>
            <span *ngIf="rowDataInfo.statusBoleto=='completed'">Completado</span>
            <span *ngIf="rowDataInfo.statusBoleto=='pending'">Aguardando Pagamento</span>
            <span *ngIf="rowDataInfo.statusBoleto!='waiting_approval' &&
                         rowDataInfo.statusBoleto!='pending' &&
                         rowDataInfo.statusBoleto!='paid' &&
                         rowDataInfo.statusBoleto!='canceled' &&
                         rowDataInfo.statusBoleto=='pending-analysis' &&
                         rowDataInfo.statusBoleto!='reserved' &&
                         rowDataInfo.statusBoleto!='error' &&
                         rowDataInfo.statusBoleto!='completed'">OUTROS</span>
        </p>
        <p>Data da última transação: {{rowDataInfo.dataTransacaoBoleto | date:'dd/MM/yyyy' }}</p>
        <p>Data de Vencimento: {{rowDataInfo.dataVencimentoBoleto | date:'dd/MM/yyyy' }}</p>
        <p *ngIf="rowDataInfo.motivoStatusBoleto!=undefined && rowDataInfo.motivoStatusBoleto!=null">
            {{rowDataInfo.motivoStatusBoleto}}
        </p>
        <p *ngIf="rowDataInfo.motivoStatusNfe!=null">{{rowDataInfo.motivoStatusNfe}}</p>

    </div>
</p-overlayPanel>

<p-overlayPanel #acoesDownload [style]="{width: '350px'}">
    <span data-toggle="tooltip" data-placement="bottom" title="Gerar Boleto">
        <a [attr.href]="rowDataInfo.linkPdfBoleto"
            class="btn btn-sm btn-secondary btn-icon">
            <i class="mdi mdi-barcode-scan"></i>Boleto(PDF)
        </a>
    </span>
    <span data-toggle="tooltip" data-placement="bottom" title="Gerar arquivo XML">
        <a [attr.href]="rowDataInfo.linkXmlNfe"
            class="btn btn-sm btn-dark btn-icon">
            <i class="mdi mdi-xml"></i>Nota (XML)
        </a>
    </span>
    <span data-toggle="tooltip" data-placement="bottom" title="Gerar Documento">
        <a [attr.href]="rowDataInfo.linkPdfNfe"
            class="btn btn-sm btn-primary btn-icon">
            <i class="mdi mdi-file-document"></i>Nota (PDF)
        </a>
    </span>
    <span data-toggle="tooltip" data-placement="bottom" title="Gerar PDF">
        <a [attr.href]="rowDataInfo.linkPdf" class="btn btn-sm btn-danger btn-icon">
            <i class="mdi mdi-file-pdf"></i>Fatura
        </a>
    </span>
    <span data-toggle="tooltip" data-placement="bottom" title="Gerar Excel">
        <a [attr.href]="rowDataInfo.linkXlsx" class="btn btn-sm btn-success btn-icon">
            <i class="mdi mdi-file-excel"></i>Consultas (XML)
        </a>
    </span>
</p-overlayPanel>

<!-- <p-overlayPanel #acoesUpload [style]="{width: '350px'}">
    <span data-toggle="tooltip" data-placement="bottom" title="Gerar Boleto">
        <a (click)="displayBoleto=true"
            class="btn btn-sm btn-secondary btn-icon">
            <i class="mdi mdi-barcode-scan"></i>Boleto(PDF)
        </a>
    </span>
    <span data-toggle="tooltip" data-placement="bottom" title="Gerar arquivo XML">
        <a *ngIf="rowDataInfo.statusNfe!='autorizada'" (click)="displayNota=true"
            class="btn btn-sm btn-dark btn-icon white">
            <i class="mdi mdi-xml"></i>Nota (XML/PDF)
        </a>
    </span>
</p-overlayPanel> -->

<!-- [breakpoints]="{'960px': '75vw', '640px': '100vw'}" -->
<p-dialog header="Insira o Boleto aqui" [modal]="true" [draggable]="false" [resizable]="false"
    [(visible)]="displayBoleto"  [style]="{width: '50vw'}"
    [transitionOptions]="'1ms'">
    <div class="row">
        <br/>
        <h2>- Verifique se há boletos carregados para a fatura selecionada -</h2>
        <br/>
        <div class="col-md-12">
            <div class="form-group">
                <p-fileUpload name="demo[]" customUpload="true" (uploadHandler)="onUpload($event, 'BoletoPDF')"
                    accept=".pdf" chooseLabel="Escolher" uploadLabel="Carregar arquivo para envio" cancelLabel="Cancelar"
                    styleClass="file-style">
                    <ng-template pTemplate="content">
                        <div *ngIf="uploadBoleto.arquivo.uploadedFiles.length">
                            <div *ngFor="let file of uploadBoleto.arquivo.uploadedFiles">
                                <button style="width: 100%;" type="button" icon="pi pi-check" pbutton=""
                                    ng-reflect-icon="pi pi-check"
                                    class="p-button p-component p-button-icon-only btn-success pull-right">
                                    <span class="p-button-icon pi pi-check" aria-hidden="true"></span><span
                                        aria-hidden="true" class="p-button-label">&amp;nbsp;</span>

                                    {{file.name}} - {{file.size}} bytes
                                </button>
                            </div>

                        </div>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
        <div class="col-6" style="max-width: 48%; margin-right: 2%;">
            <label for="valor">Valor (R$): </label>
            <input [(ngModel)]="uploadBoleto.valor" type="number" id="valor" name="valor" class="form-control" min="0.00" step="0.01">
        </div>
        <div class="col-6" style="max-width: 48%; margin-left: 2%;">
            <label for="vencimento">Data de Vencimento: </label>
            <input [(ngModel)]="uploadBoleto.vencimento" type="date" id="vencimento" name="vencimento" class="form-control">
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="updateBoleto()" label="Enviar" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<!-- [breakpoints]="{'960px': '75vw', '640px': '100vw'}" -->
<p-dialog header="Insira a Nota Fiscal aqui" [modal]="true" [draggable]="false" [resizable]="false"
    [(visible)]="displayNota"  [style]="{width: '50vw'}"
    [transitionOptions]="'1ms'">
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <p-fileUpload name="demo[]" customUpload="true" (uploadHandler)="onUpload($event, 'NotaPDF')"
                    accept=".pdf" chooseLabel="Escolher" uploadLabel="Inserir arquivo(PDF)" cancelLabel="Cancelar"
                    styleClass="file-style">
                    <ng-template pTemplate="content">
                        <div *ngIf="uploadNota.arquivoPDF.uploadedFiles.length">
                            <div *ngFor="let file of uploadNota.arquivoPDF.uploadedFiles">
                                <button style="width: 100%;" type="button" icon="pi pi-check" pbutton=""
                                    ng-reflect-icon="pi pi-check"
                                    class="p-button p-component p-button-icon-only btn-success pull-right">
                                    <span class="p-button-icon pi pi-check" aria-hidden="true"></span><span
                                        aria-hidden="true" class="p-button-label">&amp;nbsp;</span>

                                    {{file.name}} - {{file.size}} bytes
                                </button>
                            </div>

                        </div>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <p-fileUpload name="demo[]" customUpload="true" (uploadHandler)="onUpload($event, 'NotaPDF')"
                    accept=".xml" chooseLabel="Escolher" uploadLabel="Inserir arquivo(XML)" cancelLabel="Cancelar"
                    styleClass="file-style">
                    <ng-template pTemplate="content">
                        <div *ngIf="uploadNota.arquivoXML.uploadedFiles.length">
                            <div *ngFor="let file of uploadNota.arquivoXML.uploadedFiles">
                                <button style="width: 100%;" type="button" icon="pi pi-check" pbutton=""
                                    ng-reflect-icon="pi pi-check"
                                    class="p-button p-component p-button-icon-only btn-success pull-right">
                                    <span class="p-button-icon pi pi-check" aria-hidden="true"></span><span
                                        aria-hidden="true" class="p-button-label">&amp;nbsp;</span>

                                    {{file.name}} - {{file.size}} bytes
                                </button>
                            </div>

                        </div>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>

        <!--aqui-->
        <div class="col-6">
            <label for="mesCompetencia">Mês de Competência: </label>
            <p-dropdown appendTo="body" [(ngModel)]="uploadNota.mesCompetencia"
                [options]="uploadNota.mesStr" placeholder="Selecione">
                <ng-template let-option pTemplate="item">
                    <span>{{option.label}}</span>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-6">
            <label for="anoCompetencia">Ano de Competência: </label>
            <input [(ngModel)]="uploadNota.anoCompetencia" type="number" id="anoCompetencia" name="anoCompetencia" min="2000" max="3000"
                class="form-control">
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="updateNota()" label="Enviar" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<!-- [breakpoints]="{'960px': '75vw', '640px': '100vw'}" -->
<p-dialog header="Editar status de faturamento" [modal]="true" [draggable]="false" [resizable]="false"
    [(visible)]="displayEditarStatus"  [style]="{width: '50vw'}"
    [transitionOptions]="'1ms'">
    <div class="row">
        <div class="col-md-12">
            <p><span style="font-weight: bold;">ID Faturamento: </span>{{editStatus.idFaturamento}}</p>
            <p><span style="font-weight: bold;">ID Unidade: </span>{{editStatus.idUnidade}}</p>
            <p><span style="font-weight: bold;">Nome Fantasia: </span>{{editStatus.nomeFantasia}}</p>
            <p><span style="font-weight: bold;">Razão Social: </span>{{editStatus.razaoSocial}}</p>
            <p><span style="font-weight: bold;">Documento: </span>{{editStatus.documento}}</p>
            <!-- <p><span style="font-weight: bold;">Valor: </span>R$ {{editStatus.valorTotal | number:'1.2-2'}}</p> -->
            <p><span style="font-weight: bold;">Valor: </span>R$ {{editStatus.valorTotalMod}}</p>
        </div>
        <div class="col-md-6">
            <p><span style="font-weight: bold;">Status Atual: </span>
                <p-dropdown appendTo="body" [(ngModel)]="editStatus.statusFaturaCliente" [disabled]=true
                    [options]="statusFaturaCliente" placeholder="Selecione">
                    <ng-template let-option pTemplate="item">
                        <span>{{option.label}}</span>
                    </ng-template>
                </p-dropdown>
            </p>
        </div>
        <div class="col-md-6">
            <p><span style="font-weight: bold;">Status Novo: </span>
                <p-dropdown appendTo="body" [(ngModel)]="editStatus.statusFaturaClienteNovo"
                    [options]="statusFaturaCliente" placeholder="Selecione">
                    <ng-template let-option pTemplate="item">
                        <span>{{option.label}}</span>
                    </ng-template>
                </p-dropdown>
            </p>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="salvarStatus()" label="Salvar" styleClass="p-button-text">
        </p-button>
    </ng-template>
</p-dialog>

<!-- [breakpoints]="{'960px': '75vw', '640px': '100vw'}" -->
<p-dialog header="Editar status do Boleto" [modal]="true" [draggable]="false" [resizable]="false"
    [(visible)]="displayEditarStatusBoleto"  [style]="{width: '50vw'}"
    [transitionOptions]="'1ms'">
    <div class="row">
        <div class="col-md-12">
            <p><span style="font-weight: bold;">ID Unidade: </span>{{editStatusBoleto.idUnidade}}</p>
            <p><span style="font-weight: bold;">Nome Fantasia: </span>{{editStatusBoleto.nomeFantasia}}</p>
            <p><span style="font-weight: bold;">Razão Social: </span>{{editStatusBoleto.razaoSocial}}</p>
            <p><span style="font-weight: bold;">Documento: </span>{{editStatusBoleto.documento}}</p>
            <p><span style="font-weight: bold;">Data Vencimento: </span>{{editStatusBoleto.dataVencimentoBoleto | date:'dd/MM/yyyy' }}<span *ngIf ="editStatusBoleto.idBoleto == null"> Não Gerado</span></p>
            <!-- <p><span style="font-weight: bold;">Valor: </span>R$ {{editStatusBoleto.valorTotal | number:'1.2-2'}}</p> -->
            <p><span style="font-weight: bold;">Valor: </span>R$ {{editStatusBoleto.valorTotalMod}}</p>
        </div>
        <div class="col-md-6">
            <p><span style="font-weight: bold;">Status Atual: </span>
                <p-dropdown appendTo="body" [(ngModel)]="editStatusBoleto.statusBoleto" [disabled]=true
                    [options]="statusBoletos" placeholder="Selecione">
                    <ng-template let-option pTemplate="item">
                        <span>{{option.label}}</span>
                    </ng-template>
                </p-dropdown>
            </p>
        </div>
        <div class="col-md-6">
            <p><span style="font-weight: bold;">Status Novo: </span>
                <p-dropdown appendTo="body" [(ngModel)]="editStatusBoleto.statusBoletoNovo"
                    [options]="statusBoletos" placeholder="Selecione">
                    <ng-template let-option pTemplate="item">
                        <span>{{option.label}}</span>
                    </ng-template>
                </p-dropdown>
            </p>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="salvarStatusBoleto()" label="Salvar" styleClass="p-button-text">
        </p-button>
    </ng-template>
</p-dialog>
